module.exports = __webpack_public_path__ + "img/Carbon.a020937e.svg";